import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "src/store";
import { selectCurrentBrief } from "../brief";

const selectSuggestions = (state: RootState) => state.suggestions;

export const selectTopisToCover = createSelector(
  [selectSuggestions, selectCurrentBrief],
  (suggestions, brief) => {
    if (brief.id && suggestions[brief.id]) {
      return suggestions[brief.id].topicsToCover;
    }
    return [];
  }
);

export const selectStatistics = createSelector(
  [selectSuggestions, selectCurrentBrief],
  (suggestions, brief) => {
    if (brief.id && suggestions[brief.id]) {
      return suggestions[brief.id].statistics;
    }
    return [];
  }
);
export const selectLoaders = createSelector(
  [selectSuggestions, selectCurrentBrief],
  (suggestions, brief) => {
    if (brief?.id && suggestions[brief?.id]) {
      return suggestions[brief?.id].loading;
    }
    return [];
  }
);

export const selectCitedLinks = createSelector(
  [selectSuggestions, selectCurrentBrief],
  (suggestions, brief) => {
    if (brief.id && suggestions[brief.id]) {
      return suggestions[brief.id].citedLinks;
    }
    return [];
  }
);

export const selectSuggestedData = createSelector(
  [selectSuggestions, selectCurrentBrief],
  (suggestions, brief) => {
    if (brief.id && suggestions[brief.id]) {
      return {
        wordCount: suggestions[brief.id].wordCount || 0,
        headings: suggestions[brief.id].headings || 0,
        images: suggestions[brief.id].images || 0,
        contentGrade: suggestions[brief.id].contentGrade || "A",
      };
    }
    return {
      wordCount: 0,
      headings: 0,
      images: 0,
      contentGrade: "A",
    };
  }
);

export const selectSuggestedTitles = createSelector(
  [selectSuggestions, selectCurrentBrief],
  (suggestions, brief) => {
    if (brief.id && suggestions[brief.id]) {
      return suggestions[brief.id].titles;
    }
    return [];
  }
);

export const selectSuggestedDescriptions = createSelector(
  [selectSuggestions, selectCurrentBrief],
  (suggestions, brief) => {
    if (brief.id && suggestions[brief.id]) {
      return suggestions[brief.id].descriptions;
    }
    return [];
  }
);

export const selectSuggestionsLoader = createSelector(
  [selectSuggestions, selectCurrentBrief],
  (suggestions, brief) => {
    if (brief.id && suggestions[brief.id]) {
      return suggestions[brief.id].loading;
    }
    return [];
  }
);

export const selectSuggestedHeadings = createSelector(
  [selectSuggestions, selectCurrentBrief],
  (suggestions, brief) => {
    if (brief.id && suggestions[brief.id]) {
      return suggestions[brief.id].suggestedHeadings;
    }
    return [];
  }
);

export const selectIsGeneratingInstructions = createSelector(
  [selectSuggestions, selectCurrentBrief],
  (suggestions, brief) => {
    if (brief.id && suggestions[brief.id]) {
      return suggestions[brief.id].isGeneratingInstructions || false;
    }
    return false;
  }
);

export const selectIsGeneratingInstructionsForOptimize = createSelector(
  [selectSuggestions],
  (suggestions): boolean => {
    return Boolean((suggestions as any).isGeneratingInstructionsForOptimize);
  }
);

export const selectIsGeneratingProjectInstructions = createSelector(
  [selectSuggestions],
  (suggestions): boolean => {
    return Boolean((suggestions as any).isGeneratingProjectInstructions);
  }
);

export const selectIsScrapingForOptimize = createSelector(
  [selectSuggestions],
  (suggestions): boolean => {
    return Boolean((suggestions as any).isScrapingForOptimize);
  }
);

export const selectOptimizeContentLoading = createSelector(
  [selectIsGeneratingInstructionsForOptimize, selectIsScrapingForOptimize],
  (isGenerating, isScraping): boolean => {
    return isGenerating || isScraping;
  }
);
